/*
 * VigorX HR — localise the Releasit order-summary tax note.
 *
 * Releasit renders the note in English ("Including 12.00 in taxes") inside its
 * COD form summary. There is no setting for it and the node is re-rendered by
 * the app whenever the cart total changes, so this polls and rewrites it.
 *
 * Adapted from the Hungarian build (Ft / hu-HU / "Ebből ÁFA:"). Only the label
 * and the Intl locale/currency differ: Croatia is on the euro, so 2 decimals
 * are kept where the HUF version used 0. The polling interval, idempotency
 * guard, regex, number parsing and fallback branch are unchanged.
 */
setInterval(() => {
  document.querySelectorAll(".rsi-total-summary-taxes-note").forEach((element) => {
    const text = element.textContent.trim();

    // Already translated — skip
    if (text.startsWith("Uključuje PDV:")) return;

    // Capture whatever is between "Including" and "in taxes"
    const match = text.match(/Including\s+(.+?)\s+in\s+taxes/i);

    if (match) {
      const rawAmount = match[1];
      const cleanNumber = parseFloat(rawAmount.replace(/[^\d.-]/g, ''));

      if (!isNaN(cleanNumber)) {
        // Croatia has used the euro since Jan 2023 — keep 2 decimals, unlike the HUF version which used 0
        const formattedAmount = new Intl.NumberFormat('hr-HR', {
          style: 'currency',
          currency: 'EUR',
          maximumFractionDigits: 2
        }).format(cleanNumber);

        element.textContent = `Uključuje PDV: ${formattedAmount}`;
      } else {
        element.textContent = `Uključuje PDV: ${rawAmount} €`;
      }
    }
  });
}, 500);
